import React, { useMemo } from "react";
import useCommonProps from "../../../../hooks/useCommonProps";
import { Button, PositionContainer, Subtitle, Title, Wrapper } from "./styles";
import { Lang } from "@brg/api";
import useLocalization from "../../../../hooks/useLocalization";
import { ELEMENTS_POSITION } from "../../longread/postblocks/PresentationBlock/PresentationBlock";
import { useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst } from "../../../../constants/media";
export var PresentationElements = function (_a) {
    var _b, _c;
    var position = _a.position;
    var _d = useCommonProps(), additionalContent = _d.additionalContent, titleNewPosition = _d.titleNewPosition;
    var language = useLocalization().language;
    var isMac13 = useBreakpoint(LayoutConst.container.mac13);
    var isMobile = useIsMobile();
    var isS = useBreakpoint(LayoutConst.container.s - 1);
    var titleVisible = useMemo(function () { var _a; return !!((_a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.title) === null || _a === void 0 ? void 0 : _a.visible); }, [additionalContent]);
    var subtitleVisible = useMemo(function () { var _a; return !!((_a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.subtitle) === null || _a === void 0 ? void 0 : _a.visible); }, [additionalContent]);
    var buttonVisible = useMemo(function () { var _a; return !!((_a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.button) === null || _a === void 0 ? void 0 : _a.visible); }, [additionalContent]);
    var TitleBox = useMemo(function () {
        if (titleVisible) {
            var _a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.title, text = _a.text, color = _a.color;
            return (React.createElement(Title, { color: color }, Lang(text, language)));
        }
    }, [additionalContent, language]);
    var SubtitleBox = useMemo(function () {
        if (subtitleVisible) {
            var _a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.subtitle, text = _a.text, color = _a.color;
            return (React.createElement(Subtitle, { color: color }, Lang(text, language)));
        }
    }, [additionalContent, language]);
    var ButtonBox = useMemo(function () {
        if (buttonVisible) {
            var _a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.button, text = _a.text, color = _a.color, bgColor = _a.bgColor, href = _a.href;
            return (React.createElement("a", { target: '_SELF', href: href },
                React.createElement(Button, { color: color, bgColor: bgColor }, Lang(text, language))));
        }
    }, [additionalContent, language]);
    var resolution = useMemo(function () {
        if (isS) {
            return 'xs';
        }
        if (isMobile) {
            return 's';
        }
        if (isMac13) {
            return 'm';
        }
        return 'l';
    }, [
        isS,
        isMobile, isMac13
    ]);
    if (titleNewPosition === 'default' || titleNewPosition === 'default-top')
        return null;
    if ((!titleNewPosition || ((_b = [
        ELEMENTS_POSITION.outside,
        ELEMENTS_POSITION.inside
    ]) === null || _b === void 0 ? void 0 : _b.includes(titleNewPosition))) && (!position ||
        ((_c = [
            ELEMENTS_POSITION.outside,
            ELEMENTS_POSITION.inside
        ]) === null || _c === void 0 ? void 0 : _c.includes(position)) ||
        !titleVisible ||
        !subtitleVisible)) {
        return null;
    }
    return (React.createElement(PositionContainer, { position: titleNewPosition, resolution: resolution, className: 'presentation-content-elements' },
        TitleBox,
        SubtitleBox,
        ButtonBox));
};
//# sourceMappingURL=PresentatitonElements.js.mapimport React, { useMemo } from "react";
import useCommonProps from "../../../../hooks/useCommonProps";
import { Button, PositionContainer, Subtitle, Title, Wrapper } from "./styles";
import { Lang } from "@brg/api";
import useLocalization from "../../../../hooks/useLocalization";
import { ELEMENTS_POSITION } from "../../longread/postblocks/PresentationBlock/PresentationBlock";
import { useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst } from "../../../../constants/media";
export var PresentationElements = function (_a) {
    var _b, _c;
    var position = _a.position;
    var _d = useCommonProps(), additionalContent = _d.additionalContent, titleNewPosition = _d.titleNewPosition;
    var language = useLocalization().language;
    var isMac13 = useBreakpoint(LayoutConst.container.mac13);
    var isMobile = useIsMobile();
    var isS = useBreakpoint(LayoutConst.container.s - 1);
    var titleVisible = useMemo(function () { var _a; return !!((_a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.title) === null || _a === void 0 ? void 0 : _a.visible); }, [additionalContent]);
    var subtitleVisible = useMemo(function () { var _a; return !!((_a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.subtitle) === null || _a === void 0 ? void 0 : _a.visible); }, [additionalContent]);
    var buttonVisible = useMemo(function () { var _a; return !!((_a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.button) === null || _a === void 0 ? void 0 : _a.visible); }, [additionalContent]);
    var TitleBox = useMemo(function () {
        if (titleVisible) {
            var _a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.title, text = _a.text, color = _a.color;
            return (React.createElement(Title, { color: color }, Lang(text, language)));
        }
    }, [additionalContent, language]);
    var SubtitleBox = useMemo(function () {
        if (subtitleVisible) {
            var _a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.subtitle, text = _a.text, color = _a.color;
            return (React.createElement(Subtitle, { color: color }, Lang(text, language)));
        }
    }, [additionalContent, language]);
    var ButtonBox = useMemo(function () {
        if (buttonVisible) {
            var _a = additionalContent === null || additionalContent === void 0 ? void 0 : additionalContent.button, text = _a.text, color = _a.color, bgColor = _a.bgColor, href = _a.href;
            return (React.createElement("a", { target: '_SELF', href: href },
                React.createElement(Button, { color: color, bgColor: bgColor }, Lang(text, language))));
        }
    }, [additionalContent, language]);
    var resolution = useMemo(function () {
        if (isS) {
            return 'xs';
        }
        if (isMobile) {
            return 's';
        }
        if (isMac13) {
            return 'm';
        }
        return 'l';
    }, [
        isS,
        isMobile, isMac13
    ]);
    if (titleNewPosition === 'default' || titleNewPosition === 'default-top')
        return null;
    if ((!titleNewPosition || ((_b = [
        ELEMENTS_POSITION.outside,
        ELEMENTS_POSITION.inside
    ]) === null || _b === void 0 ? void 0 : _b.includes(titleNewPosition))) && (!position ||
        ((_c = [
            ELEMENTS_POSITION.outside,
            ELEMENTS_POSITION.inside
        ]) === null || _c === void 0 ? void 0 : _c.includes(position)) ||
        !titleVisible ||
        !subtitleVisible)) {
        return null;
    }
    return (React.createElement(PositionContainer, { position: titleNewPosition, resolution: resolution, className: 'presentation-content-elements' },
        TitleBox,
        SubtitleBox,
        ButtonBox));
};
//# sourceMappingURL=PresentatitonElements.js.map